import React, { createContext, useContext, useState } from "react"

import { VideoJsPlayer } from "video.js"

const vodPlayerContext = createContext<VodPlayer | null>(null)
const setVodPlayerContext = createContext<
  React.Dispatch<React.SetStateAction<VodPlayer | null>>
>(() => {})

interface Props {
  children: React.ReactNode
}

export function VodPlayerProvider({ children }: Props) {
  const [vodPlayer, setVodPlayer] = useState<VodPlayer | null>(null)

  return (
    <vodPlayerContext.Provider value={vodPlayer}>
      <setVodPlayerContext.Provider value={setVodPlayer}>
        {children}
      </setVodPlayerContext.Provider>
    </vodPlayerContext.Provider>
  )
}

export function useVodPlayer() {
  return useContext(vodPlayerContext)
}

export function useSetVodPlayer() {
  return useContext(setVodPlayerContext)
}

export interface VodPlayer extends VideoJsPlayer {
  setVolume?: (volume: string) => void
  getVolume?: () => void
  setStreamUrl?: Function
  // on: Function
  // off: Function
  // currentTime: { (seconds: number): void; (): number }
}
